import React, { FC } from 'react'
import { TableElement } from '../../templateEditor.types'
import { TemplateEditorInlineEditApi } from '../../hooks/document/useTemplateEditorInlineEdit'
import { getTableColWidths, getTableRowHeights } from '../tableListOps'
import { toDisplaySize } from '../../templateEditor.utils'
import { EditableInlineText } from './EditableInlineText'
import elementStyles from './templateEditorElementViews.jcss'

type Props = {
    element: TableElement
    scale: number
    inlineEdit: TemplateEditorInlineEditApi
}

export const TemplateEditorTableView: FC<Props> = ({ element, scale, inlineEdit }) => {
    const rowHeights = getTableRowHeights(element)
    const colWidths = getTableColWidths(element)
    const totalW = colWidths.reduce((acc, value) => acc + value, 0) || 1
    const fontSize = toDisplaySize(14, scale)
    const padding = toDisplaySize(element.cellPadding, scale)

    return (
        <div className={elementStyles.table} style={{ borderColor: element.borderColor }}>
            {element.data.map((row, rowIndex) => (
                <div
                    key={rowIndex}
                    className={elementStyles.tableRow}
                    style={{
                        height: toDisplaySize(rowHeights[rowIndex] ?? element.rowHeight, scale),
                        background: element.zebra && rowIndex % 2 === 1 ? '#f5f7fb' : '#fff',
                    }}
                >
                    {row.map((cell, colIndex) => {
                        const target = {
                            type: 'table-cell' as const,
                            elementId: element.id,
                            row: rowIndex,
                            col: colIndex,
                        }
                        const editing = inlineEdit.isEditing(target)
                        const colW = colWidths[colIndex] ?? element.colWidth

                        return (
                            <div
                                key={colIndex}
                                className={elementStyles.tableCell}
                                style={{
                                    width: `${(colW / totalW) * 100}%`,
                                    flex: `0 0 ${(colW / totalW) * 100}%`,
                                    fontSize,
                                    padding,
                                    borderColor: element.borderColor,
                                }}
                                onDoubleClick={(event) => {
                                    event.stopPropagation()
                                    inlineEdit.startInlineEdit(target)
                                }}
                            >
                                <EditableInlineText
                                    value={cell}
                                    editing={editing}
                                    className={elementStyles.editableText}
                                    onCommit={inlineEdit.commitInlineEdit}
                                    onCancel={inlineEdit.cancelInlineEdit}
                                />
                            </div>
                        )
                    })}
                </div>
            ))}
        </div>
    )
}
